var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.podcastUrl)?_c('div',{staticClass:"fragment fragment-podcast"},[_c('iframe',{style:({ width: _vm.width, height: 332 }),attrs:{"src":_vm.podcastUrl,"width":_vm.width,"height":332,"frameborder":"0","marginwidth":"0","marginheight":"0","scrolling":"no"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }